import { isThisYear } from 'date-fns';
import { PRODUCT_YEAR_ATTR } from '@yme/selectors/constants';
function getProductLastYear(product) {
    if (product && product?.variants) {
        return product?.variants
            ?.reduce((acc, item) => {
            const itemVariantYearAttr = item
                ? item.attributes.find((j) => j.name === PRODUCT_YEAR_ATTR)?.value
                : '';
            if (!acc) {
                return [itemVariantYearAttr];
            }
            return [...acc, itemVariantYearAttr];
        }, [])
            .sort()
            .at(-1);
    }
    return undefined;
}
export function getCurrentProductParameters(product) {
    const productLastYear = getProductLastYear(product);
    const isLatestModel = Boolean(productLastYear && isThisYear(productLastYear));
    const currentParameters = {
        key: product?.key,
        name: product?.name,
        productNameEn: product?.productNameEn,
        published: product?.published,
        slug: product?.slug,
        type: product?.type,
        productLastYear,
        isLatestModel,
        isCompatibleChecked: Boolean(product),
    };
    return currentParameters;
}
